import { FormDataConsumer, useTranslate } from 'ra-core'
import { BooleanInput, Labeled } from 'ra-ui-materialui'
import React from 'react'
import { productStatusChoices } from 'services/cfg/form'
import EventServiceBriefSection from 'ui-shared/FormComponents/EventServiceBriefSection'
import KRichTextInput from 'ui-shared/WrappedInputs/KRichTextInput'
import CustomizationInput from 'ui-shared/FormComponents/CustomizationInput'
import { TailoredEventSelectionInput } from 'ui-shared/FormComponents/TailoredEventSelectionInput'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import EventServiceSection from '../../EventsComponents/EventServiceSection'
import { isFoodObsolete } from '../../utils'
import { EventFormDataConsumerProps } from '../GeneralTab'
import FoodSelectionDetailsForm from './FoodSelectionDetailsForm'
import useService from '../hooks/useService'
import useSelections from '../hooks/useSelections'
import KFormTab from 'ui-shared/WrappedInputs/KFormTab'
import { Badge } from '@mui/material'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const FoodFormTab: React.FC = (props) => {
  const { hasSelections } = useSelections('foods')
  const { hasCustomization } = useService('foodService')

  const translate = useTranslate()

  return (
    <KFormTab
      {...props}
      label={
        <Badge
          badgeContent={hasSelections || hasCustomization ? 1 : 0}
          color="primary"
          variant="dot"
        >
          {translate('form.tabs.food')}
        </Badge>
      }
    >
      <KSelectInput
        source="foodStatus"
        label="form.fields.status"
        choices={productStatusChoices}
        defaultValue={productStatusChoices[0].id}
      />

      <KRichTextInput source="foodNotes" label="form.fields.notes" />

      <EventServiceSection source="foodService" />

      {/* foods input */}
      <TailoredEventSelectionInput
        entity="foods"
        label="form.fields.orders"
        source="foods"
        getIsProductObsolete={isFoodObsolete}
        disableProductChoiceAfterSelections
      >
        <FoodSelectionDetailsForm />
      </TailoredEventSelectionInput>

      <FormDataConsumer>
        {({ formData }: EventFormDataConsumerProps) => {
          const service = formData.productServices?.foodService

          return (
            <React.Fragment>
              <CustomizationInput
                source="productServices.foodService.customization"
                customization={service?.customization}
              />
              {service?.briefQuestions && service?.briefQuestions.length ? (
                <React.Fragment>
                  <Kdivider title="Event Brief" headingLevel="h3" />
                  <Labeled label="form.fields.briefConfirmation">
                    <BooleanInput
                      source={`productServices.foodService.briefConfirmed`}
                      label={service?.briefConfirmed ? 'Yes' : 'No'}
                      disabled
                    />
                  </Labeled>
                  <EventServiceBriefSection
                    serviceSource={`productServices.foodService`}
                  />
                </React.Fragment>
              ) : null}
            </React.Fragment>
          )
        }}
      </FormDataConsumer>
    </KFormTab>
  )
}

export default FoodFormTab
